import React from 'react';
import { IProps, IState } from 'containers/Product/ProductECarIns/types';
import InsTypeDefinesEN from 'constants/models/insTypeDefinesEN';
import { InsType as InsTypeEnum } from 'constants/enums/insType.enum';
import MainVisual from 'components/Home/MainVisual';
// Swiper 函式庫於 loop 模式有渲染的 bug，故更換函式庫 (2024/07/15)
// import ProdKind from 'components/Home/ProdKind';
import ProdKind02 from 'components/Home/ProdKind02';
import ProdFeature from 'components/Home/ProdFeature';
import InsureRules from 'components/Home/InsureRules';
import FlowRemind from 'components/Home/FlowRemind';
import Activity from 'components/Home/Activity';
import Service from 'components/Home/Service';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import service from 'bff/services/eCarInsHomeService';
import _ from 'lodash';
import { Program } from 'bff/models/product';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import { RecommandData } from 'bff/models/info';

class ProductECarIns extends React.Component<IProps, IState> {
  private sectionProdKindRef = React.createRef() as React.RefObject<HTMLDivElement>;

  readonly state: IState = {
    inscat: {
      BRIEF: '',
      NOTE: '',
      INS_TYPE_NAME: '',
      INS_TYPE_ID: '',
      IMAGE_LEFT_MOBILE: '',
      IMAGE_LEFT_PC: '',
      INS_TYPE_HOME_URL: '',
      SN: 0,
      IMAGE_RIGHT_PC: '',
      IMAGE_RIGHT_MOBILE: ''
    },
    programs: new Array(0),
    products: new Array(0),
    features: new Array(0),
    flows: new Array(0),
    creditCardCode: new Array(0),
    uiCode: new Array(0),
    activities: {
      ACTIVITY: [],
      MORE_ACTIVITY_URL: ''
    },
    serviceLinks: new Array(0),
    bulletin: {
      BULLETIN: {}
    },
    carLmt: new Array(new Array(0)),
    carBodyLmt: new Array(new Array(0)),
    carRecommands: {},
    programId: ''
  }

  async componentDidMount () {
    commonService.scrollToTop();

    let programId = this.props.match.params.programId || '';
    if (!this.props.match.params.programId && storageService.getItem(storageKeys.CarProgramCode)) {
      programId = storageService.getItem(storageKeys.CarProgramCode);
    }

    const initSetting = await service.fetchInitSetting(programId);
    const products = initSetting.products.filter(product => product.PROD_ID.includes('E'));
    const carRecommands = initSetting.carRecommands as Partial<RecommandData>;
    const recommands = {
      ...carRecommands,
      RECOMMAND: carRecommands.RECOMMAND && carRecommands.RECOMMAND.filter(recommand => recommand.PROD_ID.includes('E'))
    };

    this.setState({
      inscat: { ...initSetting.inscat },
      programs: [...initSetting.programs],
      products: [...products],
      features: [...initSetting.features],
      flows: [...initSetting.flows],
      creditCardCode: [...initSetting.creditCardCode],
      uiCode: [...initSetting.uiCode],
      activities: { ...initSetting.activities },
      serviceLinks: [...initSetting.serviceLinks],
      bulletin: { ...initSetting.bulletin },
      carLmt: [...initSetting.carLmt],
      carBodyLmt: [...initSetting.carBodyLmt],
      carRecommands: { ...recommands },
      programId // 於汽車首頁網址攜帶活動代碼
    });
  }

  componentDidUpdate (preProps: IProps, preState: IState) {
    /** 判斷公告事項是否更新，顯示公告事項 */
    this.handleShowBulletin(preState);
  }

  /**
   * @description 有公告事項，顯示公告
   */
  handleShowBulletin = (preState: any) => {
    const showAnnounce = Object.keys(preState.bulletin.BULLETIN).length !== Object.keys(this.state.bulletin.BULLETIN).length &&
      this.state.bulletin && this.state.bulletin.BULLETIN && this.state.bulletin.BULLETIN.END_TIME;

    if (showAnnounce && !storageService.getItem(storageKeys.CarInsAnnounceChecked)) {
      commonService.showAnnounceModal(
        this.state.bulletin.BULLETIN.END_TIME || '', this.state.bulletin.BULLETIN.TITLE, this.state.bulletin.BULLETIN.CONTENT
      );
      storageService.setItem(storageKeys.CarInsAnnounceChecked, 'checked');
    }
  }

  /**
   * @description 「主視覺」區塊點擊 SCROLL 按鈕，視窗滾動至下一個區塊 (商品種類)
   */
  handleMainVisualScrollToNextSection = () => {
    const headerHeight = document.getElementsByTagName('header')[0].clientHeight;
    if (this.sectionProdKindRef && this.sectionProdKindRef.current) {
      window.scrollTo({ top: this.sectionProdKindRef.current.offsetTop - headerHeight, behavior: 'smooth' });
    }
  };

  render () {
    // #region 主視覺
    let mainVisual;
    if (this.state.inscat.INS_TYPE_ID) {
      const backgroundImages = [
        {
          theme: InsTypeDefinesEN[InsTypeEnum.Car],
          // pcLeftImgPath: require(`assets/images/${this.state.inscat.IMAGE_LEFT_PC}`),
          // pcRightImgPath: require(`assets/images/${this.state.inscat.IMAGE_RIGHT_PC}`),
          // mobileImgPath: require(`assets/images/${this.state.inscat.IMAGE_LEFT_MOBILE}`)
          pcLeftImgPath: commonService.convertImageUrl(this.state.inscat.IMAGE_LEFT_PC),
          pcRightImgPath: commonService.convertImageUrl(this.state.inscat.IMAGE_RIGHT_PC),
          mobileImgPath: commonService.convertImageUrl(this.state.inscat.IMAGE_LEFT_MOBILE)
        }
      ];

      let newsAds;
      if (this.state.programs.length > 0) {
        newsAds = _.map(this.state.programs, (program: Program) => {
          return {
            title: program.PROGRAM_NAME,
            content: program.NOTE,
            table: program.DISCOUNT ? _.map(program.DISCOUNT, (discount: string[]) => {
              return { title: discount[0], content: discount[1] };
            }) : new Array(0)
          };
        });
      }

      mainVisual = (
        <MainVisual
          title={`旺旺友聯${this.state.inscat.INS_TYPE_NAME}(純電)`}
          subTitle={this.state.inscat.BRIEF}
          newsAds={newsAds}
          backgroundImages={backgroundImages}
          onScroll={this.handleMainVisualScrollToNextSection}
        />
      );
    }
    // #endregion

    // #region 投保流程及溫馨提醒
    let flowRemind;
    if (this.state.flows && this.state.flows.length > 0) {
      const flow = { ...this.state.flows[0] };
      const flowItems = [
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_1}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_1),
          text: flow.BRIEF_1,
          title: flow.FLOW_TITLE_1,
          subTextIndex: 5
        },
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_2}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_2),
          text: flow.BRIEF_2,
          title: flow.FLOW_TITLE_2
        },
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_3}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_3),
          text: flow.BRIEF_3,
          title: flow.FLOW_TITLE_3
        },
        {
          // icon: require(`assets/images/${flow.IMAGE_NAME_PC_4}`),
          icon: commonService.convertImageUrl(flow.IMAGE_NAME_PC_4),
          text: flow.BRIEF_4,
          title: flow.FLOW_TITLE_4
        }
      ];

      let remindAccordion;
      if (this.state.creditCardCode.length > 0) {
        remindAccordion = [
          {
            title: this.state.creditCardCode[0].NOTE,
            content: commonService.getCodeMsg(this.state.creditCardCode, CodeId.CCBANK)
          }
        ];
      }

      flowRemind = (
        <FlowRemind title="投保流程及溫馨提醒">
          <FlowRemind.Flow
            items={flowItems}
            sliderMobileConfig={{ slidesPerView: 2 }}
          />
          <FlowRemind.Table vehicleLimits={flow.VEHICLEBCLMT} />
          <FlowRemind.Remind accordion={remindAccordion}>
            {
              _.map(flow.REMIND_MSG, (str: string, index: number) => {
                return React.cloneElement(
                  <>
                    <span>{commonService.htmlParser(`<div style='display: flex;'><span>◆</span><span style='padding:0 10px'>${str}</span></div>`)}</span>
                  </>
                  , { key: index });
              })
            }
          </FlowRemind.Remind>
        </FlowRemind>
      );
    }
    // #endregion

    return (
      <div className="product-car-ins">
        {/* 主視覺 */}
        {mainVisual}
        {/* 商品種類 */}
        <ProdKind02
          products={this.state.products}
          recommands={this.state.carRecommands}
          sliderName={InsTypeDefinesEN[InsTypeEnum.Car]}
          refSetting={this.sectionProdKindRef}
          slidesPerView={3}
          programId={this.state.programId}
        />
        {/* 商品特色 */}
        <ProdFeature features={this.state.features} />
        {/* 投保規則 */}
        <InsureRules>
          <InsureRules.CarInsureRules carLmt={this.state.carLmt} carBodyLmt={this.state.carBodyLmt} />
        </InsureRules>
        {/* 投保流程及溫馨提醒 */}
        {flowRemind}
        {/* 熱門活動 */}
        <Activity activities={this.state.activities} moreActivityText={commonService.getCodeMsg(this.state.uiCode, CodeId.U017)} />
        {/* 常用服務 */}
        <Service serviceLinks={this.state.serviceLinks} />
      </div>
    );
  }
}

export default ProductECarIns;
